export default {"src":"/_next/static/media/rent-becomes-deposit.fc1f62da.svg","height":193,"width":199};